module.exports = __webpack_public_path__ + "img/Nonmotor_acc_2.b642aed9.jpg";